import { render, staticRenderFns } from "./EmergencyHelp.vue?vue&type=template&id=00a31a1e&scoped=true"
import script from "./EmergencyHelp.vue?vue&type=script&lang=js"
export * from "./EmergencyHelp.vue?vue&type=script&lang=js"
import style0 from "./EmergencyHelp.vue?vue&type=style&index=0&id=00a31a1e&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a31a1e",
  null
  
)

export default component.exports